import { Switch } from "@mui/material";
import RelayDropdown from "./Component/RelayDropDown";
import "./HomePage.css";
import React, { useState, useEffect } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import TabComponent from "./Component/TabComponent";
import BasicTabs from "./Component/TabComponent";
import AddUserForm from "./Component/AddUserForm";
import { useLocation } from 'react-router-dom';
import RingLoader from "react-spinners/RingLoader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavBar from "./Component/NavBar";


const HomePage = () => {
    const [selectedRelay, setSelectedRelay] = useState({});
    const location = useLocation();
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(true);

    // const { userData } = location.state || {};
    const notify = (message) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,


        });
    };
    useEffect(() => {
        if (location.state && location.state.user) {
            console.log("Fetched User" + location.state.user.id)
            setUser(location.state.user);
        }
    }, [location.state]);
    const handleRelaySelect = (relay) => {
        setSelectedRelay(relay);  // Update the state with the selected relay
    };

    const changeLoaderStatus = (loading) => {
        setLoading(loading);  // Update the state with the selected relay
    };


    return (
        <>
        <NavBar user={user}/>
         <div id="home-page">
            {loading && (
                <div className="loader-overlay">
                    <RingLoader loading={loading} color="white" />
                </div>
            )}
            {/* <div className="home-description-container">
                <h1>Hello Danuhsa</h1>
                <p>Simply click the toggle button to switch between open and closed states. The intuitive design ensures users can easily manage their view based on their needs, enhancing overall user experience.</p>
            </div> */}

            <RelayDropdown onSelectRelay={handleRelaySelect} user={user} changeLoaderStatus={changeLoaderStatus} />
            {
                ((selectedRelay.relay_id != null) && (user.is_admin)) ? <BasicTabs relay={selectedRelay} /> : <></>
            }

            {/* <AddUserForm/> */}
        </div>
        </>
       
    )
}

export default HomePage;